module.exports = __webpack_public_path__ + "img/pic-paging-service1-1.0e758391.jpg";